<template>
  <div>
    <div :class="`${warning_class} ${warning_class}-primary d-inline-block`" v-if="isFree">Тариф бесплатен</div>
    <div :class="`${warning_class} ${warning_class}-danger d-inline-block`" v-else-if="!paid_till">Тариф не оплачен</div>
    <div :class="`${warning_class} ${warning_class}-warning d-inline-block`" v-else-if="paid_till < today">Тариф просрочен</div>
    <div :class="`${warning_class} ${warning_class}-primary d-inline-block`" v-else-if="paid_till >= today">Тариф оплачен до {{ formatDate(paid_till) }}</div>
  </div>
</template>

<script>

import moment from "moment/moment"
import { formatDate } from "@/extensions/filters/filters"

export default {
  name: "TariffPaymentStatus",
  props: {
    paid_till: {},
    warning_class: {
      default: 'alert'
    },
    isFree: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    formatDate
  },
  computed: {
    today() {
      return moment().format('YYYY-MM-DD')
    }
  }
}
</script>
